/* @generated */
// prettier-ignore
if (Intl.NumberFormat && typeof Intl.NumberFormat.__addLocaleData === 'function') {
  Intl.NumberFormat.__addLocaleData({
  "data": {
    "currencies": {
      "AED": {
        "displayName": {
          "other": "BAA dirhami"
        },
        "narrow": "AED",
        "symbol": "AED"
      },
      "AFN": {
        "displayName": {
          "other": "Afg‘oniston afg‘oniysi"
        },
        "narrow": "؋",
        "symbol": "AFN"
      },
      "ALL": {
        "displayName": {
          "other": "Albaniya leki"
        },
        "narrow": "ALL",
        "symbol": "ALL"
      },
      "AMD": {
        "displayName": {
          "other": "Armaniston drami"
        },
        "narrow": "֏",
        "symbol": "AMD"
      },
      "ANG": {
        "displayName": {
          "other": "Niderlandiya antil guldeni"
        },
        "narrow": "ANG",
        "symbol": "ANG"
      },
      "AOA": {
        "displayName": {
          "other": "Angola kvanzasi"
        },
        "narrow": "Kz",
        "symbol": "AOA"
      },
      "ARS": {
        "displayName": {
          "other": "Argentina pesosi"
        },
        "narrow": "$",
        "symbol": "ARS"
      },
      "AUD": {
        "displayName": {
          "other": "Avstraliya dollari"
        },
        "narrow": "$",
        "symbol": "A$"
      },
      "AWG": {
        "displayName": {
          "other": "Aruba florini"
        },
        "narrow": "AWG",
        "symbol": "AWG"
      },
      "AZN": {
        "displayName": {
          "other": "Ozarbayjon manati"
        },
        "narrow": "₼",
        "symbol": "AZN"
      },
      "BAM": {
        "displayName": {
          "other": "Bosniya va Gertsegovina ayirboshlash markasi"
        },
        "narrow": "KM",
        "symbol": "BAM"
      },
      "BBD": {
        "displayName": {
          "other": "Barbados dollari"
        },
        "narrow": "$",
        "symbol": "BBD"
      },
      "BDT": {
        "displayName": {
          "other": "Bangladesh takasi"
        },
        "narrow": "৳",
        "symbol": "BDT"
      },
      "BGN": {
        "displayName": {
          "other": "Bolgariya levi"
        },
        "narrow": "BGN",
        "symbol": "BGN"
      },
      "BHD": {
        "displayName": {
          "other": "Bahrayn dinori"
        },
        "narrow": "BHD",
        "symbol": "BHD"
      },
      "BIF": {
        "displayName": {
          "other": "Burundi franki"
        },
        "narrow": "BIF",
        "symbol": "BIF"
      },
      "BMD": {
        "displayName": {
          "other": "Bermuda dollari"
        },
        "narrow": "$",
        "symbol": "BMD"
      },
      "BND": {
        "displayName": {
          "other": "Bruney dollari"
        },
        "narrow": "$",
        "symbol": "BND"
      },
      "BOB": {
        "displayName": {
          "other": "Boliviya bolivianosi"
        },
        "narrow": "Bs",
        "symbol": "BOB"
      },
      "BRL": {
        "displayName": {
          "other": "Braziliya reali"
        },
        "narrow": "R$",
        "symbol": "R$"
      },
      "BSD": {
        "displayName": {
          "other": "Bagama dollari"
        },
        "narrow": "$",
        "symbol": "BSD"
      },
      "BTN": {
        "displayName": {
          "other": "Butan ngultrumi"
        },
        "narrow": "BTN",
        "symbol": "BTN"
      },
      "BWP": {
        "displayName": {
          "other": "Botsvana pulasi"
        },
        "narrow": "P",
        "symbol": "BWP"
      },
      "BYN": {
        "displayName": {
          "other": "Belarus rubli"
        },
        "narrow": "р.",
        "symbol": "BYN"
      },
      "BYR": {
        "displayName": {
          "other": "Belarus rubli (2000–2016)"
        },
        "narrow": "BYR",
        "symbol": "BYR"
      },
      "BZD": {
        "displayName": {
          "other": "Beliz dollari"
        },
        "narrow": "$",
        "symbol": "BZD"
      },
      "CAD": {
        "displayName": {
          "other": "Kanada dollari"
        },
        "narrow": "$",
        "symbol": "CA$"
      },
      "CDF": {
        "displayName": {
          "other": "Kongo franki"
        },
        "narrow": "CDF",
        "symbol": "CDF"
      },
      "CHF": {
        "displayName": {
          "other": "Shveytsariya franki"
        },
        "narrow": "CHF",
        "symbol": "CHF"
      },
      "CLP": {
        "displayName": {
          "other": "Chili pesosi"
        },
        "narrow": "$",
        "symbol": "CLP"
      },
      "CNH": {
        "displayName": {
          "other": "Xitoy yuani (ofshor)"
        },
        "narrow": "CNH",
        "symbol": "CNH"
      },
      "CNY": {
        "displayName": {
          "other": "Xitoy yuani"
        },
        "narrow": "¥",
        "symbol": "CN¥"
      },
      "COP": {
        "displayName": {
          "other": "Kolumbiya pesosi"
        },
        "narrow": "$",
        "symbol": "COP"
      },
      "CRC": {
        "displayName": {
          "other": "Kosta-Rika koloni"
        },
        "narrow": "₡",
        "symbol": "CRC"
      },
      "CUC": {
        "displayName": {
          "other": "Kuba ayirboshlash pesosi"
        },
        "narrow": "$",
        "symbol": "CUC"
      },
      "CUP": {
        "displayName": {
          "other": "Kuba pesosi"
        },
        "narrow": "$",
        "symbol": "CUP"
      },
      "CVE": {
        "displayName": {
          "other": "Kabo-Verde eskudosi"
        },
        "narrow": "CVE",
        "symbol": "CVE"
      },
      "CZK": {
        "displayName": {
          "other": "Chexiya kronasi"
        },
        "narrow": "Kč",
        "symbol": "CZK"
      },
      "DJF": {
        "displayName": {
          "other": "Jibuti franki"
        },
        "narrow": "DJF",
        "symbol": "DJF"
      },
      "DKK": {
        "displayName": {
          "other": "Daniya kronasi"
        },
        "narrow": "kr",
        "symbol": "DKK"
      },
      "DOP": {
        "displayName": {
          "other": "Dominikana pesosi"
        },
        "narrow": "$",
        "symbol": "DOP"
      },
      "DZD": {
        "displayName": {
          "other": "Jazoir dinori"
        },
        "narrow": "DZD",
        "symbol": "DZD"
      },
      "EGP": {
        "displayName": {
          "other": "Misr funti"
        },
        "narrow": "E£",
        "symbol": "EGP"
      },
      "ERN": {
        "displayName": {
          "other": "Eritreya nakfasi"
        },
        "narrow": "ERN",
        "symbol": "ERN"
      },
      "ESP": {
        "displayName": {
        },
        "narrow": "₧",
        "symbol": "ESP"
      },
      "ETB": {
        "displayName": {
          "other": "Efiopiya biri"
        },
        "narrow": "ETB",
        "symbol": "ETB"
      },
      "EUR": {
        "displayName": {
          "other": "yevro"
        },
        "narrow": "€",
        "symbol": "€"
      },
      "FJD": {
        "displayName": {
          "other": "Fiji dollari"
        },
        "narrow": "$",
        "symbol": "FJD"
      },
      "FKP": {
        "displayName": {
          "other": "Folklend orollari funti"
        },
        "narrow": "£",
        "symbol": "FKP"
      },
      "GBP": {
        "displayName": {
          "other": "Angliya funt sterlingi"
        },
        "narrow": "£",
        "symbol": "£"
      },
      "GEL": {
        "displayName": {
          "other": "Gruziya larisi"
        },
        "narrow": "₾",
        "symbol": "GEL"
      },
      "GHS": {
        "displayName": {
          "other": "Gana sedisi"
        },
        "narrow": "GH₵",
        "symbol": "GHS"
      },
      "GIP": {
        "displayName": {
          "other": "Gibraltar funti"
        },
        "narrow": "£",
        "symbol": "GIP"
      },
      "GMD": {
        "displayName": {
          "other": "Gambiya dalasisi"
        },
        "narrow": "GMD",
        "symbol": "GMD"
      },
      "GNF": {
        "displayName": {
          "other": "Gvineya franki"
        },
        "narrow": "FG",
        "symbol": "GNF"
      },
      "GTQ": {
        "displayName": {
          "other": "Gvatemala ketsali"
        },
        "narrow": "Q",
        "symbol": "GTQ"
      },
      "GYD": {
        "displayName": {
          "other": "Gayana dollari"
        },
        "narrow": "$",
        "symbol": "GYD"
      },
      "HKD": {
        "displayName": {
          "other": "Gonkong dollari"
        },
        "narrow": "$",
        "symbol": "HK$"
      },
      "HNL": {
        "displayName": {
          "other": "Gonduras lempirasi"
        },
        "narrow": "L",
        "symbol": "HNL"
      },
      "HRK": {
        "displayName": {
          "other": "Xorvatiya kunasi"
        },
        "narrow": "kn",
        "symbol": "HRK"
      },
      "HTG": {
        "displayName": {
          "other": "Gaiti gurdi"
        },
        "narrow": "HTG",
        "symbol": "HTG"
      },
      "HUF": {
        "displayName": {
          "other": "Vengriya forinti"
        },
        "narrow": "Ft",
        "symbol": "HUF"
      },
      "IDR": {
        "displayName": {
          "other": "Indoneziya rupiyasi"
        },
        "narrow": "Rp",
        "symbol": "IDR"
      },
      "ILS": {
        "displayName": {
          "other": "Isroil yangi shekeli"
        },
        "narrow": "₪",
        "symbol": "₪"
      },
      "INR": {
        "displayName": {
          "other": "Hindiston rupiyasi"
        },
        "narrow": "₹",
        "symbol": "₹"
      },
      "IQD": {
        "displayName": {
          "other": "Iroq dinori"
        },
        "narrow": "IQD",
        "symbol": "IQD"
      },
      "IRR": {
        "displayName": {
          "other": "Eron riyoli"
        },
        "narrow": "IRR",
        "symbol": "IRR"
      },
      "ISK": {
        "displayName": {
          "other": "Islandiya kronasi"
        },
        "narrow": "kr",
        "symbol": "ISK"
      },
      "JMD": {
        "displayName": {
          "other": "Yamayka dollari"
        },
        "narrow": "$",
        "symbol": "JMD"
      },
      "JOD": {
        "displayName": {
          "one": "Yordaniya dinori",
          "other": "Iordaniya dinori"
        },
        "narrow": "JOD",
        "symbol": "JOD"
      },
      "JPY": {
        "displayName": {
          "other": "Yaponiya iyenasi"
        },
        "narrow": "¥",
        "symbol": "JP¥"
      },
      "KES": {
        "displayName": {
          "other": "Keniya shillingi"
        },
        "narrow": "KES",
        "symbol": "KES"
      },
      "KGS": {
        "displayName": {
          "other": "Qirg‘iziston somi"
        },
        "narrow": "KGS",
        "symbol": "KGS"
      },
      "KHR": {
        "displayName": {
          "other": "Kambodja rieli"
        },
        "narrow": "៛",
        "symbol": "KHR"
      },
      "KMF": {
        "displayName": {
          "other": "Komor orollari franki"
        },
        "narrow": "CF",
        "symbol": "KMF"
      },
      "KPW": {
        "displayName": {
          "other": "Shimoliy Koreya voni"
        },
        "narrow": "₩",
        "symbol": "KPW"
      },
      "KRW": {
        "displayName": {
          "other": "Janubiy Koreya voni"
        },
        "narrow": "₩",
        "symbol": "₩"
      },
      "KWD": {
        "displayName": {
          "other": "Kuvayt dinori"
        },
        "narrow": "KWD",
        "symbol": "KWD"
      },
      "KYD": {
        "displayName": {
          "other": "Kayman orollari dollari"
        },
        "narrow": "$",
        "symbol": "KYD"
      },
      "KZT": {
        "displayName": {
          "other": "Qozog‘iston tengesi"
        },
        "narrow": "₸",
        "symbol": "KZT"
      },
      "LAK": {
        "displayName": {
          "other": "Laos kipi"
        },
        "narrow": "₭",
        "symbol": "LAK"
      },
      "LBP": {
        "displayName": {
          "other": "Livan funti"
        },
        "narrow": "L£",
        "symbol": "LBP"
      },
      "LKR": {
        "displayName": {
          "other": "Shri-Lanka rupiyasi"
        },
        "narrow": "Rs",
        "symbol": "LKR"
      },
      "LRD": {
        "displayName": {
          "other": "Liberiya dollari"
        },
        "narrow": "$",
        "symbol": "LRD"
      },
      "LSL": {
        "displayName": {
          "other": "Lesoto lotisi"
        },
        "narrow": "LSL",
        "symbol": "LSL"
      },
      "LTL": {
        "displayName": {
          "other": "Litva liti"
        },
        "narrow": "Lt",
        "symbol": "LTL"
      },
      "LVL": {
        "displayName": {
          "other": "Latviya lati"
        },
        "narrow": "Ls",
        "symbol": "LVL"
      },
      "LYD": {
        "displayName": {
          "other": "Liviya dinori"
        },
        "narrow": "LYD",
        "symbol": "LYD"
      },
      "MAD": {
        "displayName": {
          "other": "Marokash dirhami"
        },
        "narrow": "MAD",
        "symbol": "MAD"
      },
      "MDL": {
        "displayName": {
          "other": "Moldova leyi"
        },
        "narrow": "MDL",
        "symbol": "MDL"
      },
      "MGA": {
        "displayName": {
          "other": "Malagasi ariarisi"
        },
        "narrow": "Ar",
        "symbol": "MGA"
      },
      "MKD": {
        "displayName": {
          "other": "Makedoniya dinori"
        },
        "narrow": "MKD",
        "symbol": "MKD"
      },
      "MMK": {
        "displayName": {
          "other": "Myanma kyati"
        },
        "narrow": "K",
        "symbol": "MMK"
      },
      "MNT": {
        "displayName": {
          "other": "Mongoliya tugriki"
        },
        "narrow": "₮",
        "symbol": "MNT"
      },
      "MOP": {
        "displayName": {
          "other": "Makao patakasi"
        },
        "narrow": "MOP",
        "symbol": "MOP"
      },
      "MRO": {
        "displayName": {
          "other": "Mavritaniya uqiyasi (1973–2017)"
        },
        "narrow": "MRO",
        "symbol": "MRO"
      },
      "MRU": {
        "displayName": {
          "other": "Mavritaniya uqiyasi"
        },
        "narrow": "MRU",
        "symbol": "MRU"
      },
      "MUR": {
        "displayName": {
          "other": "Mavritaniya rupiyasi"
        },
        "narrow": "Rs",
        "symbol": "MUR"
      },
      "MVR": {
        "displayName": {
          "other": "Maldiv rupiyasi"
        },
        "narrow": "MVR",
        "symbol": "MVR"
      },
      "MWK": {
        "displayName": {
          "other": "Malavi kvachasi"
        },
        "narrow": "MWK",
        "symbol": "MWK"
      },
      "MXN": {
        "displayName": {
          "other": "Meksika pesosi"
        },
        "narrow": "$",
        "symbol": "MX$"
      },
      "MYR": {
        "displayName": {
          "other": "Malayziya ringgiti"
        },
        "narrow": "RM",
        "symbol": "MYR"
      },
      "MZN": {
        "displayName": {
          "other": "Mozambik metikali"
        },
        "narrow": "MZN",
        "symbol": "MZN"
      },
      "NAD": {
        "displayName": {
          "other": "Namibiya dollari"
        },
        "narrow": "$",
        "symbol": "NAD"
      },
      "NGN": {
        "displayName": {
          "other": "Nigeriya nayrasi"
        },
        "narrow": "₦",
        "symbol": "NGN"
      },
      "NIO": {
        "displayName": {
          "other": "Nikaragua kordobasi"
        },
        "narrow": "C$",
        "symbol": "NIO"
      },
      "NOK": {
        "displayName": {
          "other": "Norvegiya kronasi"
        },
        "narrow": "kr",
        "symbol": "NOK"
      },
      "NPR": {
        "displayName": {
          "other": "Nepal rupiyasi"
        },
        "narrow": "Rs",
        "symbol": "NPR"
      },
      "NZD": {
        "displayName": {
          "other": "Yangi Zelandiya dollari"
        },
        "narrow": "$",
        "symbol": "NZ$"
      },
      "OMR": {
        "displayName": {
          "other": "Ummon riyoli"
        },
        "narrow": "OMR",
        "symbol": "OMR"
      },
      "PAB": {
        "displayName": {
          "other": "Panama balboasi"
        },
        "narrow": "PAB",
        "symbol": "PAB"
      },
      "PEN": {
        "displayName": {
          "other": "Peru soli"
        },
        "narrow": "PEN",
        "symbol": "PEN"
      },
      "PGK": {
        "displayName": {
          "other": "Papua – Yangi Gvineya kinasi"
        },
        "narrow": "PGK",
        "symbol": "PGK"
      },
      "PHP": {
        "displayName": {
          "other": "Filippin pesosi"
        },
        "narrow": "₱",
        "symbol": "PHP"
      },
      "PKR": {
        "displayName": {
          "other": "Pokiston rupiyasi"
        },
        "narrow": "Rs",
        "symbol": "PKR"
      },
      "PLN": {
        "displayName": {
          "other": "Polsha zlotiyi"
        },
        "narrow": "zł",
        "symbol": "PLN"
      },
      "PYG": {
        "displayName": {
          "other": "Paragvay guaranisi"
        },
        "narrow": "₲",
        "symbol": "PYG"
      },
      "QAR": {
        "displayName": {
          "other": "Qatar riyoli"
        },
        "narrow": "QAR",
        "symbol": "QAR"
      },
      "RON": {
        "displayName": {
          "other": "Ruminiya leyi"
        },
        "narrow": "lei",
        "symbol": "RON"
      },
      "RSD": {
        "displayName": {
          "other": "Serbiya dinori"
        },
        "narrow": "RSD",
        "symbol": "RSD"
      },
      "RUB": {
        "displayName": {
          "other": "Rossiya rubli"
        },
        "narrow": "₽",
        "symbol": "RUB"
      },
      "RWF": {
        "displayName": {
          "other": "Ruanda franki"
        },
        "narrow": "RF",
        "symbol": "RWF"
      },
      "SAR": {
        "displayName": {
          "other": "Saudiya Arabistoni riyoli"
        },
        "narrow": "SAR",
        "symbol": "SAR"
      },
      "SBD": {
        "displayName": {
          "other": "Solomon orollari dollari"
        },
        "narrow": "$",
        "symbol": "SBD"
      },
      "SCR": {
        "displayName": {
          "other": "Seyshel rupiyasi"
        },
        "narrow": "SCR",
        "symbol": "SCR"
      },
      "SDG": {
        "displayName": {
          "other": "Sudan funti"
        },
        "narrow": "SDG",
        "symbol": "SDG"
      },
      "SEK": {
        "displayName": {
          "other": "Shvetsiya kronasi"
        },
        "narrow": "kr",
        "symbol": "SEK"
      },
      "SGD": {
        "displayName": {
          "other": "Singapur dollari"
        },
        "narrow": "$",
        "symbol": "SGD"
      },
      "SHP": {
        "displayName": {
          "other": "Muqaddas Yelena oroli funti"
        },
        "narrow": "£",
        "symbol": "SHP"
      },
      "SLL": {
        "displayName": {
          "other": "Syerra-Leone leonesi"
        },
        "narrow": "SLL",
        "symbol": "SLL"
      },
      "SOS": {
        "displayName": {
          "other": "Somali shillingi"
        },
        "narrow": "SOS",
        "symbol": "SOS"
      },
      "SRD": {
        "displayName": {
          "other": "Surinam dollari"
        },
        "narrow": "$",
        "symbol": "SRD"
      },
      "SSP": {
        "displayName": {
          "other": "Janubiy Sudan funti"
        },
        "narrow": "£",
        "symbol": "SSP"
      },
      "STD": {
        "displayName": {
          "other": "San-Tome va Prinsipi dobrasi (1977–2017)"
        },
        "narrow": "STD",
        "symbol": "STD"
      },
      "STN": {
        "displayName": {
          "other": "San-Tome va Prinsipi dobrasi"
        },
        "narrow": "Db",
        "symbol": "STN"
      },
      "SYP": {
        "displayName": {
          "other": "Suriya funti"
        },
        "narrow": "£",
        "symbol": "SYP"
      },
      "SZL": {
        "displayName": {
          "other": "Svazilend lilangenisi"
        },
        "narrow": "SZL",
        "symbol": "SZL"
      },
      "THB": {
        "displayName": {
          "other": "Tailand bati"
        },
        "narrow": "฿",
        "symbol": "THB"
      },
      "TJS": {
        "displayName": {
          "other": "Tojikiston somoniysi"
        },
        "narrow": "TJS",
        "symbol": "TJS"
      },
      "TMT": {
        "displayName": {
          "other": "Turkmaniston manati"
        },
        "narrow": "TMT",
        "symbol": "TMT"
      },
      "TND": {
        "displayName": {
          "other": "Tunis dinori"
        },
        "narrow": "TND",
        "symbol": "TND"
      },
      "TOP": {
        "displayName": {
          "other": "Tonga paangasi"
        },
        "narrow": "T$",
        "symbol": "TOP"
      },
      "TRY": {
        "displayName": {
          "other": "Turk lirasi"
        },
        "narrow": "₺",
        "symbol": "TRY"
      },
      "TTD": {
        "displayName": {
          "other": "Trinidad va Tobago dollari"
        },
        "narrow": "$",
        "symbol": "TTD"
      },
      "TWD": {
        "displayName": {
          "other": "Yangi Tayvan dollari"
        },
        "narrow": "$",
        "symbol": "NT$"
      },
      "TZS": {
        "displayName": {
          "other": "Tanzaniya shillingi"
        },
        "narrow": "TZS",
        "symbol": "TZS"
      },
      "UAH": {
        "displayName": {
          "other": "Ukraina grivnasi"
        },
        "narrow": "₴",
        "symbol": "UAH"
      },
      "UGX": {
        "displayName": {
          "other": "Uganda shillingi"
        },
        "narrow": "UGX",
        "symbol": "UGX"
      },
      "USD": {
        "displayName": {
          "other": "AQSH dollari"
        },
        "narrow": "$",
        "symbol": "US$"
      },
      "UYU": {
        "displayName": {
          "other": "Urugvay pesosi"
        },
        "narrow": "$",
        "symbol": "UYU"
      },
      "UZS": {
        "displayName": {
          "other": "O‘zbekiston so‘mi"
        },
        "narrow": "soʻm",
        "symbol": "soʻm"
      },
      "VEF": {
        "displayName": {
          "other": "Venesuela bolivari (2008–2018)"
        },
        "narrow": "Bs",
        "symbol": "VEF"
      },
      "VES": {
        "displayName": {
          "other": "Venesuela bolivari"
        },
        "narrow": "VES",
        "symbol": "VES"
      },
      "VND": {
        "displayName": {
          "other": "Vyetnam dongi"
        },
        "narrow": "₫",
        "symbol": "₫"
      },
      "VUV": {
        "displayName": {
          "other": "Vanuatu vatusi"
        },
        "narrow": "VUV",
        "symbol": "VUV"
      },
      "WST": {
        "displayName": {
          "other": "Samoa talasi"
        },
        "narrow": "WST",
        "symbol": "WST"
      },
      "XAF": {
        "displayName": {
          "other": "Markaziy Afrika CFA franki"
        },
        "narrow": "FCFA",
        "symbol": "FCFA"
      },
      "XCD": {
        "displayName": {
          "other": "Sharqiy Karib dollari"
        },
        "narrow": "$",
        "symbol": "EC$"
      },
      "XOF": {
        "displayName": {
          "other": "G‘arbiy Afrika CFA franki"
        },
        "narrow": "F CFA",
        "symbol": "F CFA"
      },
      "XPF": {
        "displayName": {
          "other": "Fransuz Polineziyasi franki"
        },
        "narrow": "CFPF",
        "symbol": "CFPF"
      },
      "XXX": {
        "displayName": {
          "other": "(noma’lum valyuta)"
        },
        "narrow": "¤",
        "symbol": "¤"
      },
      "YER": {
        "displayName": {
          "other": "Yaman riyoli"
        },
        "narrow": "YER",
        "symbol": "YER"
      },
      "ZAR": {
        "displayName": {
          "other": "Janubiy Afrika rendi"
        },
        "narrow": "R",
        "symbol": "ZAR"
      },
      "ZMW": {
        "displayName": {
          "other": "Zambiya kvachasi"
        },
        "narrow": "ZK",
        "symbol": "ZMW"
      }
    },
    "nu": [
      "latn"
    ],
    "numbers": {
      "currency": {
        "latn": {
          "accounting": "¤#,##0.00;(¤#,##0.00)",
          "currencySpacing": {
            "afterInsertBetween": " ",
            "beforeInsertBetween": " "
          },
          "short": {
            "1000": {
              "other": "0 ming ¤"
            },
            "10000": {
              "other": "00 ming ¤"
            },
            "100000": {
              "other": "000 ming ¤"
            },
            "1000000": {
              "other": "0 mln ¤"
            },
            "10000000": {
              "other": "00 mln ¤"
            },
            "100000000": {
              "other": "000 mln ¤"
            },
            "1000000000": {
              "other": "0 mlrd ¤"
            },
            "10000000000": {
              "other": "00 mlrd ¤"
            },
            "100000000000": {
              "other": "000 mlrd ¤"
            },
            "1000000000000": {
              "other": "0 trln ¤"
            },
            "10000000000000": {
              "other": "00 trln ¤"
            },
            "100000000000000": {
              "other": "000 trln ¤"
            }
          },
          "standard": "#,##0.00 ¤",
          "unitPattern": "{0} {1}"
        }
      },
      "decimal": {
        "latn": {
          "long": {
            "1000": {
              "other": "0 ming"
            },
            "10000": {
              "other": "00 ming"
            },
            "100000": {
              "other": "000 ming"
            },
            "1000000": {
              "other": "0 million"
            },
            "10000000": {
              "other": "00 million"
            },
            "100000000": {
              "other": "000 million"
            },
            "1000000000": {
              "other": "0 milliard"
            },
            "10000000000": {
              "other": "00 milliard"
            },
            "100000000000": {
              "other": "000 milliard"
            },
            "1000000000000": {
              "other": "0 trillion"
            },
            "10000000000000": {
              "other": "00 trillion"
            },
            "100000000000000": {
              "other": "000 trillion"
            }
          },
          "short": {
            "1000": {
              "other": "0 ming"
            },
            "10000": {
              "other": "00 ming"
            },
            "100000": {
              "other": "000 ming"
            },
            "1000000": {
              "other": "0 mln"
            },
            "10000000": {
              "other": "00 mln"
            },
            "100000000": {
              "other": "000 mln"
            },
            "1000000000": {
              "other": "0 mlrd"
            },
            "10000000000": {
              "other": "00 mlrd"
            },
            "100000000000": {
              "other": "000 mlrd"
            },
            "1000000000000": {
              "other": "0 trln"
            },
            "10000000000000": {
              "other": "00 trln"
            },
            "100000000000000": {
              "other": "000 trln"
            }
          },
          "standard": "#,##0.###"
        }
      },
      "nu": [
        "latn"
      ],
      "percent": {
        "latn": "#,##0%"
      },
      "symbols": {
        "latn": {
          "approximatelySign": "~",
          "decimal": ",",
          "exponential": "E",
          "group": " ",
          "infinity": "∞",
          "list": ";",
          "minusSign": "-",
          "nan": "son emas",
          "perMille": "‰",
          "percentSign": "%",
          "plusSign": "+",
          "rangeSign": "–",
          "superscriptingExponent": "×",
          "timeSeparator": ":"
        }
      }
    },
    "units": {
      "compound": {
        "per": {
          "long": "{0}/{1}",
          "narrow": "{0}/{1}",
          "short": "{0}/{1}"
        }
      },
      "simple": {
        "acre": {
          "long": {
            "other": "{0} akr"
          },
          "narrow": {
            "other": "{0} ac"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} akr"
          }
        },
        "bit": {
          "long": {
            "other": "{0} bit"
          },
          "narrow": {
            "other": "{0} bit"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} bit"
          }
        },
        "byte": {
          "long": {
            "other": "{0} bayt"
          },
          "narrow": {
            "other": "{0} bayt"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} bayt"
          }
        },
        "celsius": {
          "long": {
            "other": "{0} Selsiy darajasi"
          },
          "narrow": {
            "other": "{0}°C"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0}°C"
          }
        },
        "centimeter": {
          "long": {
            "other": "{0} santimetr"
          },
          "narrow": {
            "other": "{0} sm"
          },
          "perUnit": {
            "long": "{0}/santimetr",
            "narrow": "{0}/sm",
            "short": "{0}/sm"
          },
          "short": {
            "other": "{0} sm"
          }
        },
        "day": {
          "long": {
            "other": "{0} kun"
          },
          "narrow": {
            "other": "{0} kun"
          },
          "perUnit": {
            "long": "{0}/kun",
            "narrow": "{0}/kun",
            "short": "{0}/kun"
          },
          "short": {
            "other": "{0} kun"
          }
        },
        "degree": {
          "long": {
            "other": "{0} gradus"
          },
          "narrow": {
            "other": "{0}°"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} grad"
          }
        },
        "fahrenheit": {
          "long": {
            "other": "{0} Farengeyt darajasi"
          },
          "narrow": {
            "other": "{0}°F"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0}°F"
          }
        },
        "fluid-ounce": {
          "long": {
            "other": "{0} suyuq unsiya"
          },
          "narrow": {
            "other": "{0} suyuq unsiya"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} suyuq unsiya"
          }
        },
        "foot": {
          "long": {
            "other": "{0} fut"
          },
          "narrow": {
            "other": "{0} fut"
          },
          "perUnit": {
            "long": "{0}/fut",
            "narrow": "{0} fut",
            "short": "{0} fut"
          },
          "short": {
            "other": "{0} fut"
          }
        },
        "gallon": {
          "long": {
            "other": "{0} gallon"
          },
          "narrow": {
            "other": "{0} gal"
          },
          "perUnit": {
            "long": "{0}/gallon",
            "narrow": "{0}/gal",
            "short": "{0}/gal"
          },
          "short": {
            "other": "{0} gal"
          }
        },
        "gigabit": {
          "long": {
            "other": "{0} gigabit"
          },
          "narrow": {
            "other": "{0} Gbit"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} Gbit"
          }
        },
        "gigabyte": {
          "long": {
            "other": "{0} gigabayt"
          },
          "narrow": {
            "other": "{0} GB"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} GB"
          }
        },
        "gram": {
          "long": {
            "other": "{0} gramm"
          },
          "narrow": {
            "other": "{0} g"
          },
          "perUnit": {
            "long": "{0}/gramm",
            "narrow": "{0}/g",
            "short": "{0}/g"
          },
          "short": {
            "other": "{0} g"
          }
        },
        "hectare": {
          "long": {
            "other": "{0} gektar"
          },
          "narrow": {
            "other": "{0} ha"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} ga"
          }
        },
        "hour": {
          "long": {
            "other": "{0} soat"
          },
          "narrow": {
            "other": "{0} soat"
          },
          "perUnit": {
            "long": "{0}/soat",
            "narrow": "{0}/soat",
            "short": "{0}/soat"
          },
          "short": {
            "other": "{0} soat"
          }
        },
        "inch": {
          "long": {
            "other": "{0} duym"
          },
          "narrow": {
            "other": "{0} dyuym"
          },
          "perUnit": {
            "long": "{0}/duym",
            "narrow": "{0}/dy",
            "short": "{0}/dy"
          },
          "short": {
            "other": "{0} dy"
          }
        },
        "kilobit": {
          "long": {
            "other": "{0} kilobit"
          },
          "narrow": {
            "other": "{0} kbit"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} kbit"
          }
        },
        "kilobyte": {
          "long": {
            "other": "{0} kilobayt"
          },
          "narrow": {
            "other": "{0} kB"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} kB"
          }
        },
        "kilogram": {
          "long": {
            "other": "{0} kilogramm"
          },
          "narrow": {
            "other": "{0} kg"
          },
          "perUnit": {
            "long": "{0}/kilogramm",
            "narrow": "{0}/kg",
            "short": "{0}/kg"
          },
          "short": {
            "other": "{0} kg"
          }
        },
        "kilometer": {
          "long": {
            "other": "{0} kilometr"
          },
          "narrow": {
            "other": "{0} km"
          },
          "perUnit": {
            "long": "{0}/kilometr",
            "narrow": "{0}/km",
            "short": "{0}/km"
          },
          "short": {
            "other": "{0} km"
          }
        },
        "kilometer-per-hour": {
          "long": {
            "other": "{0} km/soat"
          },
          "narrow": {
            "other": "{0} km/soat"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} km/soat"
          }
        },
        "liter": {
          "long": {
            "other": "{0} litr"
          },
          "narrow": {
            "other": "{0}L"
          },
          "perUnit": {
            "long": "{0}/litr",
            "narrow": "{0}/L",
            "short": "{0}/L"
          },
          "short": {
            "other": "{0} L"
          }
        },
        "liter-per-kilometer": {
          "long": {
            "other": "{0} litr/kilometr"
          },
          "narrow": {
            "other": "{0} L/km"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} L/km"
          }
        },
        "megabit": {
          "long": {
            "other": "{0} megabit"
          },
          "narrow": {
            "other": "{0} Mbit"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} Mbit"
          }
        },
        "megabyte": {
          "long": {
            "other": "{0} megabayt"
          },
          "narrow": {
            "other": "{0} MB"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} MB"
          }
        },
        "meter": {
          "long": {
            "other": "{0} metr"
          },
          "narrow": {
            "other": "{0} m"
          },
          "perUnit": {
            "long": "{0}/metr",
            "narrow": "{0}/m",
            "short": "{0}/m"
          },
          "short": {
            "other": "{0} m"
          }
        },
        "meter-per-second": {
          "long": {
            "other": "{0} metr/soniya"
          },
          "narrow": {
            "other": "{0} m/s"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} m/s"
          }
        },
        "mile": {
          "long": {
            "other": "{0} mil"
          },
          "narrow": {
            "other": "{0} milya"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} mil"
          }
        },
        "mile-per-gallon": {
          "long": {
            "other": "{0} mil/gallon"
          },
          "narrow": {
            "other": "{0} mil/gal"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} mil/gal"
          }
        },
        "mile-per-hour": {
          "long": {
            "other": "{0} mil/soat"
          },
          "narrow": {
            "other": "{0} mi/h"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} mil/soat"
          }
        },
        "mile-scandinavian": {
          "long": {
            "other": "{0} skandinav mili"
          },
          "narrow": {
            "other": "{0} sk. mili"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} sk. mili"
          }
        },
        "milliliter": {
          "long": {
            "other": "{0} millilitr"
          },
          "narrow": {
            "other": "{0} mL"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} mL"
          }
        },
        "millimeter": {
          "long": {
            "other": "{0} millimetr"
          },
          "narrow": {
            "other": "{0} mm"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} mm"
          }
        },
        "millisecond": {
          "long": {
            "other": "{0} millisoniya"
          },
          "narrow": {
            "other": "{0} ms"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} ms"
          }
        },
        "minute": {
          "long": {
            "other": "{0} daqiqa"
          },
          "narrow": {
            "other": "{0} daq."
          },
          "perUnit": {
            "long": "{0}/daqiqa",
            "narrow": "{0}/daq.",
            "short": "{0}/daq."
          },
          "short": {
            "other": "{0} daq."
          }
        },
        "month": {
          "long": {
            "other": "{0} oy"
          },
          "narrow": {
            "other": "{0} oy"
          },
          "perUnit": {
            "long": "{0}/oy",
            "narrow": "{0}/oy",
            "short": "{0}/oy"
          },
          "short": {
            "other": "{0} oy"
          }
        },
        "ounce": {
          "long": {
            "other": "{0} unsiya"
          },
          "narrow": {
            "other": "{0} untsiya"
          },
          "perUnit": {
            "long": "{0}/unsiya",
            "narrow": "{0}/unsiya",
            "short": "{0}/unsiya"
          },
          "short": {
            "other": "{0} unsiya"
          }
        },
        "percent": {
          "long": {
            "other": "{0} foiz"
          },
          "narrow": {
            "other": "{0}%"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0}%"
          }
        },
        "petabyte": {
          "long": {
            "other": "{0} petabayt"
          },
          "narrow": {
            "other": "{0} PB"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} PB"
          }
        },
        "pound": {
          "long": {
            "other": "{0} funt"
          },
          "narrow": {
            "other": "{0} funt"
          },
          "perUnit": {
            "long": "{0}/funt",
            "narrow": "{0}/funt",
            "short": "{0}/funt"
          },
          "short": {
            "other": "{0} funt"
          }
        },
        "second": {
          "long": {
            "other": "{0} soniya"
          },
          "narrow": {
            "other": "{0} s"
          },
          "perUnit": {
            "long": "{0}/soniya",
            "narrow": "{0}/s",
            "short": "{0}/s"
          },
          "short": {
            "other": "{0} son."
          }
        },
        "stone": {
          "long": {
            "other": "{0} tosh"
          },
          "narrow": {
            "other": "{0} tosh"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} tosh"
          }
        },
        "terabit": {
          "long": {
            "other": "{0} terabit"
          },
          "narrow": {
            "other": "{0} Tbit"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} Tbit"
          }
        },
        "terabyte": {
          "long": {
            "other": "{0} terabayt"
          },
          "narrow": {
            "other": "{0} TB"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} TB"
          }
        },
        "week": {
          "long": {
            "other": "{0} hafta"
          },
          "narrow": {
            "other": "{0} hafta"
          },
          "perUnit": {
            "long": "{0}/hafta",
            "narrow": "{0}/hafta",
            "short": "{0}/hafta"
          },
          "short": {
            "other": "{0} hafta"
          }
        },
        "yard": {
          "long": {
            "other": "{0} yard"
          },
          "narrow": {
            "other": "{0} yard"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} yard"
          }
        },
        "year": {
          "long": {
            "other": "{0} yil"
          },
          "narrow": {
            "other": "{0} yil"
          },
          "perUnit": {
            "long": "{0}/yil",
            "narrow": "{0}/yil",
            "short": "{0}/yil"
          },
          "short": {
            "other": "{0} yil"
          }
        }
      }
    }
  },
  "locale": "uz"
})
}